<script setup lang="ts">
import type {StringSchema, StringValue} from '@/generated-report/interfaces';
import FieldDescription from "@/generated-report/components/form-schema/fields/FieldDescription.vue";
import {Textarea} from "@/core/components/ui/textarea";
import {useTextareaAutosize} from "@vueuse/core";
import {computed, ref} from "vue";

const {schema, nestingLevel = 1 } = defineProps<{
  schema: StringSchema;
  nestingLevel?: number;
}>();

const value = defineModel<StringValue>({ required: false, default: "" });
const textareaComponent = ref();

const textareaElement = computed(() => textareaComponent.value?.$el);


useTextareaAutosize({input: value, element: textareaElement});

</script>

<template>
  <div class="space-y-2">
    <FieldDescription :nesting-level="nestingLevel">
      {{ schema.description }}
    </FieldDescription>
    <Textarea ref="textareaComponent" v-model="value" type="text" class="bg-white w-full min-h-[30px]" />
  </div>
</template>

<style scoped>
:deep(textarea) {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

:deep(textarea::-webkit-scrollbar) {
    display: none;
}
</style>
